module.exports = __webpack_public_path__ + "img/首页品牌SCAEG.png";